import React from "react";
import {getCountryName} from "../../util/countryCodes";
import {Select} from "antd";

const CountrySelect = ({ country, userSubscriptions, setShowModal }) => {

    const hasNoSubscriptions = !userSubscriptions || userSubscriptions.length === 0;

    return (country && <div>
        <Select
            disabled={!hasNoSubscriptions}
            className='common-select'
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            notFoundContent={null}
            value={country && getCountryName(country)}
            onClick={(e) => {
                e.preventDefault();
                if(hasNoSubscriptions) {
                    setShowModal(true);
                }
            }}
        >
        </Select>
    </div>)
}

export default CountrySelect